/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import Backbone from 'backbone';
import ChartTypeCollection from '../collection/ChartTypeCollection';

export default Backbone.Model.extend({
    defaults: {
        id: undefined,
        name: undefined,
        bundleName: undefined,
        chartTypes: []
    },
    initialize: function () {
        this.chartTypesCollection = new ChartTypeCollection(this.get('chartTypes'));
    },
    toJSON: function () {
        var json = Backbone.Model.prototype.toJSON.call(this);
        json.chartTypes = this.chartTypesCollection.toJSON();
        return json;
    }
});
